const Stars = ({ rating }: { rating: string }) => {
  const value = parseFloat(rating);

  if (isNaN(value)) {
    return null;
  }

  return (
    <span aria-label={`${value} out of 5 stars`} className="text-[10px]">
      {Array.from({ length: 5 }, (_, i) => {
        const diff = value - i;

        if (diff >= 1) {
          return <span key={i}>★</span>;
        }
        if (diff >= 0.5) {
          return (
            <span className="relative inline-block" key={i}>
              <span className="text-base-content/20">★</span>
              <span className="absolute inset-0 overflow-hidden w-1/2">★</span>
            </span>
          );
        }
        return (
          <span className="text-base-content/20" key={i}>
            ★
          </span>
        );
      })}
    </span>
  );
};

export default Stars;
